<div class="badge badge-lg badge-outline-secondary ms-1">{{ params?.data?.type
    }} <span *ngIf="params?.data?.type=='Tranche'||params?.data?.type=='Increase'">{{params?.data?.trancheNumber}}</span></div>